export const submitAnIdea = "SUBMIT_AN_IDEA";
export const submitAnIdeaSuccess = "SUBMIT_AN_IDEA_SUCCESS"
export const submitAnIdeaFailed = "SUBMIT_AN_IDEA_FAILED"
export const updated = "SUBMIT_AN_IDEA_UPDATED"
export const reset = "RESET"